import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import {
	GetAllCitizenshipsWithTranslation,
	GetAllCountriesWithTranslation,
} from 'utils/countryHelpers'
import { IApplicationInformation } from 'interfaces/i-application-information'

export const NationalityFormUK = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'NationalityForm',
		collapsable: false,
		description: t('Nationality and residency'),
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'countryOfBirth',
				type: 'dropdown',
				label: t('forms:CountryOfBirth'),
				options: GetAllCountriesWithTranslation(appConfig.country),
				value: data?.personalInfo?.countryOfBirth,
				required: true,
				visible: true,
				col: 6,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownCountry'),
			},
			{
				controlName: 'countryOfResidence',
				type: 'dropdown',
				label: t('forms:CountryOfResidence'),
				options: GetAllCountriesWithTranslation(appConfig.country),
				value: data?.address?.countryOfResidence,
				required: true,
				visible: true,
				col: 6,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownCountry'),
				viewGroup: { id: 'currentAddress', isPrimary: false },
			},
			{
				controlName: 'citizenship',
				type: 'dropdown',
				label: t('forms:Citizenship'),
				value: data?.personalInfo?.citizenship?.join(',') || '',
				options: GetAllCitizenshipsWithTranslation(appConfig.country),
				multiple: true,
				required: true,
				visible: true,
				col: 12,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownCountry'),
			},
		],
	}
}
